import { createNetworkQuery } from '@/services/revenueApi/createNetworkQuery';
import type {
  CampaignsApiResponse,
  EarningsApiResponse,
  MetadataApiResponse,
  CampaignTypesApiResponse,
  NetworkShow,
  NetworkShowSummary,
  TopAdvertiser,
} from '@/types';

export const useAdvertisersQuery = createNetworkQuery<
  TopAdvertiser[],
  { showIds?: string[]; limit?: number }
>('top-advertisers', (networkId) => `/v2/networks/${networkId}/ongoing/top-advertisers`);

export const useCampaignsQuery = createNetworkQuery<
  CampaignsApiResponse,
  { showIds?: string[] }
>('campaigns', (networkId) => `/v2/networks/${networkId}/ongoing/campaigns`);

export const useCampaignTypesQuery = createNetworkQuery<
  CampaignTypesApiResponse,
  { showIds?: string[] }
>('campaigns-types', (networkId) => `/v2/networks/${networkId}/ongoing/campaign-types`);

export const useEarningsQuery = createNetworkQuery<
  EarningsApiResponse,
  { showIds?: string[] }
>('earnings', (networkId) => `/v2/networks/${networkId}/ongoing/earnings`);

export const useShowPerformanceQuery = createNetworkQuery<
  NetworkShow[],
  { limit?: number; showIds?: string[] }
>('show-performance', (networkId) => `/v2/networks/${networkId}/ongoing/shows`);

export const useShowsSummaryQuery = createNetworkQuery<NetworkShowSummary[]>(
  'shows-summary',
  (networkId) => `/v2/networks/${networkId}/ongoing/shows-summary`
);

// TODO: this is only used on payouts page, but it can likely be removed completely
export const useMetadataQuery = createNetworkQuery<MetadataApiResponse>(
  'metadata',
  (networkId) => `/networks/${networkId}/ongoing/metadata`
);
